module.exports = __webpack_public_path__ + "img/1.1b728dd2.png";